import React, { useContext } from 'react';
import { ConfigurationManager, ConfigurationContext } from '../utils/config';

/**
 * Create Context Consumer HOC for `ConfigurationContext`, reads config data from context and pass it to children via props
 *
 * @param {String} [configPath] - retrieve nested config object according to supplied object path (dot notation)
 * @param {String} [propName] - prop name is used for config manager instance. Default `config`
 * @returns {function(*): function(*=, *): *}
 */
export const withConfig =
  ({ configPath, propName = 'config' } = { propName: 'config' }) =>
  (Component) => {
    const ConfigConsumer = (props) => {
      let config = useContext(ConfigurationContext);

      if (!(config instanceof ConfigurationManager)) {
        throw new Error(
          'AppConfigConsumer: invalid context data, probably component has not been wrapped into "<ConfigurationContextProvider/>"',
        );
      }

      if (configPath) {
        // TODO: might cause unneeded re-rendering due to creation of new config manager instance
        config = config.createChild(configPath);
      }

      const newProps = Object.assign({}, props, { [propName]: config });

      return <Component {...newProps} />;
    };

    ConfigConsumer.displayName = `ConfigConsumer(${Component.displayName || Component.name})`;

    return ConfigConsumer;
  };

export default withConfig;
